module.exports = __webpack_public_path__ + "img/1sb_serta_with_sheep_logo_mob_v1.79fd14d.svg";